import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getAuditTrail = async ({
  audit_type_id,
  start_date,
  end_date,
  page,
  size,
}) => {
  let queryParams = `page=${page}&page_size=${size}`;
  if (audit_type_id) {
    queryParams = `${queryParams}&audit_type_id=${audit_type_id}`;
  }
  if (start_date) {
    queryParams = `${queryParams}&start_date=${start_date}`;
  }
  if (end_date) {
    queryParams = `${queryParams}&end_date=${end_date}`;
  }
  const data = await getData(`${ajaxEndpoints.PRODUCT_AUDITS}?${queryParams}`);
  return data;
};

export default function useAuditTrail({
  audit_type_id,
  start_date,
  end_date,
  page,
  size,
}) {
  return useQuery(
    [{ audit_type_id, start_date, end_date, page, size }, "getAuditTrail"],
    getAuditTrail
  );
}
